let captured;

/**
 * The page skeleton server.js served (with slots filled by the cloudflare worker), captured the first time this is
 * called: AppInitializer empties #skeleton once the app has mounted. Only the content area, as the app renders its
 * own nav bar.
 * @return {Object|null} { html, path } (the skeleton's markup and the path it was served for), or null if there wasn't
 *                       one
 */
export default function serverSkeleton() {
  if (captured === undefined) {
    const element = document.querySelector('#skeleton .content.body-placeholder');
    captured = element && element.innerHTML
      ? { html: element.innerHTML, path: window.location.pathname }
      : null;
  }

  return captured;
}
